export default function Icon5() {
    return (
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M30.8496 21.4004C30.8496 20.4893 30.1113 19.7502 29.2002 19.75H17.2002C16.2889 19.75 15.5498 20.4891 15.5498 21.4004V28.5996C15.5498 29.5109 16.2889 30.25 17.2002 30.25H29.2002C30.1113 30.2498 30.8496 29.5107 30.8496 28.5996V21.4004ZM33.75 26.7998V23.2002C33.75 22.786 34.0858 22.4502 34.5 22.4502C34.9141 22.4503 35.25 22.7861 35.25 23.2002V26.7998C35.25 27.2139 34.9141 27.5497 34.5 27.5498C34.0858 27.5498 33.75 27.214 33.75 26.7998ZM32.3496 28.5996C32.3496 30.3392 30.9397 31.7498 29.2002 31.75H17.2002C15.4605 31.75 14.0498 30.3393 14.0498 28.5996V21.4004C14.0498 19.6607 15.4605 18.25 17.2002 18.25H29.2002C30.9397 18.2502 32.3496 19.6608 32.3496 21.4004V28.5996Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.3335 10.4168C8.3335 9.26623 9.26624 8.3335 10.4168 8.3335H39.5835C40.7341 8.3335 41.6668 9.26624 41.6668 10.4168V39.5835C41.6668 40.7341 40.7341 41.6668 39.5835 41.6668H10.4168C9.26623 41.6668 8.3335 40.7341 8.3335 39.5835V10.4168Z"
                stroke="currentColor"
                stroke-width="1.875"
            />
        </svg>
    );
}
